import { Checkbox, DataSource, Label, Layout, NumberEditor, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDuplicateOrderPrompt extends Layout {
    checkboxExciseTaxes: Checkbox;
    checkboxHandlingReq: Checkbox;
    checkboxIncludeOtherCharges: Checkbox;
    checkboxIncludeRate: Checkbox;
    checkboxPerItem: Checkbox;
    labelNumberOfOrdersToCreate: Label;
    labelQuestion: Label;
    numbereditorOrdersCreate: NumberEditor;
    panelBrLTLOptions: Panel;
    panelExciseTaxOptions: Panel;
    panelOrderOptions: Panel;
    sourceCopyControl: DataSource;
}
